// src/Pages/RentCar.js
import React from "react";
import { Link } from "react-router-dom";
import { products } from "../data/carsData";

function RentCar() {
  return (
    <div className="container mx-auto py-10 px-4">
      {/* Page Header */}
      <div className="text-center mb-10">
        <h1 className="text-4xl font-extrabold text-gray-900">
          🚘 Rent Your Dream Car
        </h1>
        <p className="mt-3 text-gray-600 max-w-2xl mx-auto">
          Choose from our wide range of premium cars and enjoy a smooth ride —
          hourly, daily, or weekly.
        </p>
      </div>

      {/* Products Grid */}
      <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {products["rent-car"].map((prod) => (
          <Link
            key={prod.id}
            to={`/product/${prod.id}`}
            state={prod}
            className="group bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl hover:scale-[1.02] transition transform"
          >
            {/* Car Image */}
            <div className="relative">
              <img
                src={prod.image}
                alt={prod.name}
                className="w-full h-48 object-cover group-hover:opacity-90 transition"
              />
              <span className="absolute top-3 left-3 bg-indigo-600 text-white text-xs font-medium px-3 py-1 rounded-full shadow">
                Available
              </span>
            </div>

            {/* Car Info */}
            <div className="p-5">
              <h3 className="text-lg font-bold text-gray-900 group-hover:text-indigo-600 transition">
                {prod.name}
              </h3>
              <p className="mt-2 text-sm text-gray-600 line-clamp-2">
                {prod.description || "Luxury, comfort, and performance."}
              </p>
              <div className="mt-4 flex justify-between items-center">
                <span className="text-xl font-semibold text-indigo-600">
                  $   {prod?.price ? prod.price :0 }
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default RentCar;